// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3E9_Q","colBig":"styles_colBig__318f4","colSmall":"styles_colSmall__3Rao1"};